import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FormNumericField } from "@/components/UiKit"
import { FIELD_LABEL_CLASSES } from "@/constants/forms"
import NumericTypeField from "@/screens/Pricing/components/forms/NumericTypeField"

const PriceChangeField: FC = () => {
  const { control } = useFormContext()

  return (
    <Box>
      <label htmlFor='priceChange' className={FIELD_LABEL_CLASSES}>
        Desired Price Change
      </label>

      <Box className='flex gap-1'>
        <Box className='w-[90px]'>
          <FormNumericField
            control={control}
            name='priceChange'
            data-testid='price-change.bulk-update-form.price-change-field'
          />
        </Box>

        <NumericTypeField name='priceChangeType' />
      </Box>
    </Box>
  )
}

export default PriceChangeField
